<div *ngIf="data" class="p-5">
    <h2>{{ data.title | translate }}</h2>
    <p class="mb-4">{{ data.msg | translate }}</p>
    <div class="d-flex justify-content-end gap-3">
        <button mat-button (click)="submit(false)">{{ data.negativeBtnText | translate }}</button>
        <button mat-button (click)="submit(true)">{{ data.positiveBtnText | translate }}</button>
    </div>
</div>
